import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import Home from './Home';
import Privacy from './Privacy';
import Apply from './Apply';
import LoanProducts from './LoanProducts';
import ContactUs from './ContactUs';
import AboutUs from './AboutUs';
import Technology from "./Technology";
import HomeNew from "./HomeNew";
import Career from "./Career";
import PrivacyStaffApp from './PrivacyStaffApp';
import PrivacyCustomerApp from './PrivacyCustomerApp';
import PressRelease from './PressRelease'
import JobDescription from './JobDescription';
import PartnerWithUs from './PartnerWithUs';
import EANdSPolicies from './EAndSPolicies';
import EmiCalculator from './EmiCalculator';
import CustomerGrievance from './CustomerGrievance';
import FairPracticeCode from './FairPracticeCode';

class Main extends Component {

  componentDidUpdate(prevProps) {
     if (this.props.location !== prevProps.location) {
       this.onRouteChanged();
     }
   }

   onRouteChanged() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <main>
        <Switch>
          {/*<Route exact path="/" render={() => <Home history={this.props.history} selectedLanguage={this.props.selectedLanguage}/>} />*/}
          <Route exact path="/" component={HomeNew} />
          <Route
            exact
            path="/products"
            render={() => <LoanProducts history={this.props.history} selectedLanguage={this.props.selectedLanguage} />}
          />
          <Route exact path="/apply" component={Apply} />
          <Route exact path="/about_us" component={AboutUs} />
          <Route exact path="/privacy" component={Privacy} />
          <Route exact path="/contact" render={() => <ContactUs history={this.props.history} />} />
          {/* <Route exact path="/technology" component={Technology} /> */}
          {/* <Route exact path="/career" component={Career} /> */}
          <Route exact path="/privacy_app" component={PrivacyStaffApp} />
          <Route exact path="/privacy_customer_app" component={PrivacyCustomerApp} />
          <Route exact path="/press-release" component={PressRelease} />
          <Route exact path="/job_description/:id" component={JobDescription} />
          <Route exact path="/partner_with_us"  component={PartnerWithUs}/>
          <Route exact path="/environmental_and_social_policy"  component={EANdSPolicies}/>
          <Route exact path="/emi_calculator" component={EmiCalculator} />
          <Route exact path="/customer_grievance" component={CustomerGrievance} />
          <Route exact path="/fair_practice_code" component={FairPracticeCode} />
        </Switch>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  selectedLanguage: state.defaultLanguage
});

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));



// WEBPACK FOOTER //
// ./src/components/Main.js